import {
  IonApp,
  IonContent,
  IonPage,
  IonRouterOutlet,
  setupIonicReact,
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";
/* Optional CSS utils that can be commented out */
import "@ionic/react/css/display.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/float-elements.css";
/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/typography.css";
/* Theme variables */
import "./theme/variables.css";

import { useEffect } from "react";
import { Redirect, Route } from "react-router-dom";
import Account from "./components/Account/Account";
import AddReal from "./components/AddReal/AddReal";
import Book from "./components/Book/Book";
import Competence from "./components/Competence/Competence";
import Datasheets from "./components/Datasheets/Datasheets";
import PageNotFound from "./components/ErrorComponent/PageNotFound/PageNotFound";
import Feed from "./components/Feed/Feed";
import ForgotPassword from "./components/ForgotPassword/ForgotPassword";
import ResetPassword from "./components/ForgotPassword/ResetPassword";
import Generique from "./components/Generiques/Generique";
import Login from "./components/Login/Login";
import NestedRoute from "./components/NestedRoute.tsx/NestedRoute";
import NextLives from "./components/NextLives/NextLives";
import RealMarked from "./components/ReceiveReal/realMarked";
import RegisterDELICEO from "./components/Register/RegisterDELICEO";
import RegisterFORMACEO from "./components/Register/RegisterFORMACEO";
import Replay from "./components/Replay/Replay";
import TechnoList from "./components/TechnoList/TechnoList";
import VideoDisplay from "./components/Video/Video";
import VideoGen from "./components/Video/VideoGen";
import VideoReplay from "./components/Video/VideoReplay";
import Welcome from "./components/Welcome/Welcome";
import WorkAside from "./components/WorkAside/WorkAside";
import FormalPratique from "./pages/FormalPratique/FormalPratique";
import FormalPratiqueSkill from "./pages/FormalPratique/FormalPratiqueSkill";
import FormalPratiqueTheme from "./pages/FormalPratique/FormalPratiqueTheme";
import { makePATCHRequest } from "./request/rawRequest";

setupIonicReact();

const getMonday = () => {
  const now = new Date();
  const dayOfWeek = now.getDay();
  const date = now.getDate();
  const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
  const monday = new Date(now.getFullYear(), now.getMonth(), date - diff);
  return monday;
};

const App: React.FC = () => {
  const appName = process.env.REACT_APP_NAME;
  const pathLogo = appName === "FORMACEO" ? "assets/logo/formaceoReverse.png" : "assets/logo/deliceo_logo_crop.png";
  const timeToAdd = 30000;

  const handleUserTimeAdder = async () => {
    if (localStorage.getItem("authToken")) {
      await makePATCHRequest("/time", {
        time: timeToAdd,
        week_nb: getMonday().getTime(),
      });
    }
  };

  const Register = appName === "FORMACEO" ? RegisterFORMACEO : RegisterDELICEO;

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleUserTimeAdder();
    }, timeToAdd);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  return (
    <IonApp>
      <IonPage color="primary">
        <IonContent className="main-container">
          <IonReactRouter>
            <IonRouterOutlet>
              {/* if not token go to home */}
              <Route exact path="/forgotPassword">
                <ForgotPassword pathLogo={pathLogo} />
              </Route>
              <Route exact path="/resetPassword">
                <ResetPassword pathLogo={pathLogo} />
              </Route>

              <Route exact path="/">
                {localStorage.getItem("authToken") !== null ? (
                  <Redirect to="/auth/welcome/" />
                ) : localStorage.getItem("authToken") === null ? (
                  <Login pathLogo={pathLogo} />
                ) : (
                  <Redirect to="/techno/welcome/" />
                )}
              </Route>

              <NestedRoute
                path="/techno"
                condition={localStorage.getItem("authToken") === null}
              >
                <Route exact path="/login">
                  <TechnoList pathLogo={pathLogo} />
                </Route>
                <Route exact path="/register">
                  <Register pathLogo={pathLogo}/>
                </Route>
              </NestedRoute>

              <NestedRoute
                path="/auth"
                condition={localStorage.getItem("authToken") !== null}
              >
                <Route exact path="/feed">
                  <Feed />
                </Route>
                <Route exact path="/account">
                  <Account />
                </Route>

                <Route exact path="/nextLives">
                  <NextLives />
                </Route>
                <Route exact path="/addReal">
                  <AddReal />
                </Route>
                <Route exact path="/realMarked">
                  <RealMarked />
                </Route>
                <Route exact path="/datasheets">
                  <Datasheets />
                </Route>
                <Route exact path="/replay">
                  <Replay />
                </Route>
                <Route exact path="/videoreplay">
                  <VideoReplay />
                </Route>
                <Route exact path="/welcome">
                  <Welcome />
                </Route>
                <Route exact path="/book">
                  <Book />
                </Route>
                <Route exact path="/formalPratique">
                  <FormalPratique />
                </Route>
                <Route exact path="/formalPratique/:id/:id">
                  <FormalPratiqueTheme />
                </Route>
                <Route exact path="/formalPratique/:id">
                  <FormalPratiqueSkill />
                </Route>
                <Route exact path="/workaside">
                  <WorkAside />
                </Route>

                <NestedRoute
                  path="/pole"
                  condition={localStorage.getItem("pole") !== null}
                >
                  <Route exact path="/competences">
                    <Competence />
                  </Route>
                  <Route exact path="/generiques">
                    <Generique />
                  </Route>

                  <Route exact path="/video">
                    <VideoDisplay />
                  </Route>
                  <Route exact path="/videogen">
                    <VideoGen />
                  </Route>
                </NestedRoute>
              </NestedRoute>

              <Route exact path="/404">
                <PageNotFound />
              </Route>

              {/* keep this last */}
              {/* <Route>
                <Redirect to="/404" />
              </Route> */}
            </IonRouterOutlet>
          </IonReactRouter>
        </IonContent>
      </IonPage>
    </IonApp>
  );
};

export default App;
